module.exports = __webpack_public_path__ + "static/Niamh-9cadb22e63f35f08ab998b73d1104b95.png";